import { Component, Input } from '@angular/core';
import { UI_CONSTANTS } from '@edassist/shared';
import { ValidationErrors } from '@angular/forms';
import { CustomErrorMessage } from '../models/custom-error-message.interface';

@Component({
	selector: 'ea-form-control-error',
	templateUrl: './form-control-error.component.html',
	styleUrls: ['./form-control-error.component.scss']
})
export class FormControlErrorComponent {
	@Input() submitted: boolean;
	@Input() errors: ValidationErrors;
	@Input() customErrors: Array<CustomErrorMessage>;
	@Input() controlName? = 'Field';

	UI_CONSTANTS = UI_CONSTANTS;
}
